import styled from 'styled-components';

const ColorModalCloseButtonContainer = styled.div`
    position: absolute;
    right: 0;
    top: 0;
`;

export default ColorModalCloseButtonContainer;
